<template>
	  <v-text-field
        hide-details dense outlined
        :clearable="!blocked" clear-icon="mdi-close-circle-outline"
        :disabled="!!blocked"
        :label="label"
        :ref="name"
        :value="value"
        :placeholder="label"
        :reverse="reverse[format]"
        @input="$emit('changed', $event)"
        autocomplete="new-password"
    ></v-text-field>
</template>
<script>
export default {
    name: 'TextInput',
    props: ['label', 'format', 'name', 'value', 'blocked'],
    data: () => ({
        reverse: { 'default': false, 'number': true, 'date': false, 'decimal': true, 'euro': true, 'proz': true }
    }),
    mounted() {
        //console.log('TextInput[' + this.name + ']:', this.format, this.reverse[this.format])
    },
}
</script>